export default __webpack_public_path__ + "static/media/theme_zita_logo.766dad44.png";